const pt = {
  common: {
    loading: 'Carregando...',
    error: 'Erro',
    save: 'Salvar',
    cancel: 'Cancelar',
    delete: 'Excluir',
    edit: 'Editar',
    moveUp: 'Mover para cima',
    moveDown: 'Mover para baixo',
    close: 'Fechar',
    confirm: 'Confirmar',
    search: 'Pesquisar',
    filter: 'Filtrar',
    export: 'Exportar',
    yes: 'Sim',
    no: 'Não',
    back: 'Voltar',
    next: 'Próximo',
    submit: 'Enviar',
    darkMode: 'Modo escuro',
    lightMode: 'Modo claro',
    languageMenuTitle: 'Mudar idioma',
    pagerShow: 'Mostrar',
    pagerPerPage: 'por página',
    pagerOf: 'de',
    viewCards: 'Vista em cartões',
    viewList: 'Vista em lista',
    collapse: 'Recolher',
    expand: 'Expandir',
    previousPage: 'Página anterior',
    nextPage: 'Próxima página',
    retry: 'Tentar novamente',
    errorBoundaryTitle: 'Algo deu errado',
    errorGeneric: 'Ocorreu um erro inesperado. Por favor tente novamente.',
    expandModal: 'Expandir em modal',
    resetToGlobal: 'Redefinir para global',
    appName: 'Sigma Pulse',
  },
  nav: {
    home: 'Início',
    growth: 'Crescimento',
    admin: 'Administração',
    executive: 'Executivo',
    analytics: 'Analytics',
    switchDemoProfile: 'Alternar perfil de demonstração',
    mobileNav: 'Navegação principal',
  },
  roles: {
    employee: 'Funcionário',
    adminOU: 'Admin UA',
    adminGlobal: 'Admin Global',
  },
  platform: {
    teams: 'TEAMS',
  },
  survey: {
    title: 'Pesquisas pendentes',
    pending: 'Pendente',
    completed: 'Concluída',
    expired: 'Expirada',
    submit: 'Enviar avaliação',
    skip: 'Pular',
    noObs: 'Sem observação',
    meeting: 'Reunião',
    duration: 'Duração',
    participants: 'Participantes',
    simulateMeeting: 'Simular fim de reunião',
    thankYou: 'Obrigado pela sua avaliação!',
    evaluating: 'Avaliando',
    of: 'de',
    question: 'Pergunta',
    selectResponse: 'Selecione uma resposta',
    nps: {
      question: 'Qual a probabilidade de recomendar trabalhar com esta pessoa?',
      detractor: 'Detrator',
      passive: 'Passivo',
      promoter: 'Promotor',
    },
    evaluateNow: 'Avaliar agora',
    postpone: 'Depois',
    expires: 'Expira',
    noSurveysPending: 'Sem pesquisas pendentes! Bom trabalho.',
    weekCompleted: 'sem.',
    likert: {
      always: 'Sempre',
      usually: 'Quase sempre',
      sometimes: 'Às vezes',
      rarely: 'Quase nunca',
      notObservable: 'Não observável',
    },
    questions: {
      listenedActivelyText: 'Esta pessoa ouviu ativamente e demonstrou interesse genuíno?',
      sharedKnowledgeText: 'Compartilhou conhecimento ou experiências relevantes durante a sessão?',
    },
    completeSubtitle: 'Seu feedback ajuda a fortalecer a cultura da equipe.',
    backToHome: 'Voltar ao início',
    greetingMorning: 'Bom dia',
    greetingAfternoon: 'Boa tarde',
    greetingEvening: 'Boa noite',
    pendingCountPre: 'Você tem',
    pendingCountSingular: 'pesquisa pendente',
    pendingCountPlural: 'pesquisas pendentes',
    allDoneTitle: 'Tudo em dia!',
    allDoneSubtitle: 'Você não tem pesquisas pendentes. Elas aparecerão aqui após sua próxima reunião.',
    omit: 'Omitir',
    omitSurvey: 'Omitir pesquisa',
    submitSuccess: 'Respostas enviadas',
    submitError: 'Erro ao enviar — tente novamente',
    omitSuccess: 'Pesquisa omitida',
    omitError: 'Erro ao omitir — tente novamente',
    kpi: {
      answered: 'Respondidas',
      omitted: 'Omitidas',
      streak: 'Sequência',
      participation: 'Participação',
    },
    growth: {
      title: 'Seu crescimento espera por você',
      message: 'Revise seus resultados, tendências e áreas de desenvolvimento no painel de crescimento.',
      cta: 'Ver meu crescimento',
    },
    tips: {
      title: 'Dicas para você',
      based: 'Baseadas na sua pontuação média',
      empty: 'Complete mais pesquisas para ver dicas personalizadas',
      reconocer: 'Para reconhecer',
      crecer: 'Para crescer',
      tipOfDay: 'Dica do dia',
    },
  },
  safe: {
    title: 'Meu Crescimento',
    subtitle: 'Seu desenvolvimento cultural na Sigma',
    sectionName: 'Meu feedback',
    surveysAnswered: 'Pesquisas respondidas',
    score: 'Sua Pontuação',
    evolution: 'Sua evolução',
    evolutionSub: 'Sua jornada pessoal — só você, sem comparações',
    radarTitle: 'Seu perfil por Fundamental',
    radarSub: 'Você hoje vs você há 3 meses',
    fundamentals: 'Fundamentos',
    fundamentalsChart: 'Seu feedback por Fundamental',
    fundamentalsChartSub: 'Onde você está em cada um — clique em qualquer barra para detalhe',
    behaviors: 'Comportamentos',
    kudos: 'Reconhecimentos',
    kudosTitle: 'Para Reconhecer — o que você mais traz',
    kudosSub: 'O que seus colegas mais observam em você este mês',
    actions: 'Plano de ação',
    omissions: 'Omissões',
    period: 'Período',
    received: 'Recebidas',
    sent: 'Enviadas',
    areaAverage: 'Média da área',
    today: 'Hoje (Jan 2026)',
    threeMonthsAgo: 'Há 3 meses (Out 2025)',
    detail: 'Detalhe',
    profileTitle: 'Seu perfil cultural em palavras',
    profileSub: 'Comportamentos, não números',
    basedOn: 'Com base em {{count}} feedbacks anônimos',
    level0: 'Início',
    level1: 'Em desenvolvimento',
    level2: 'Consistente',
    level3: 'Referência',
    level0desc: 'Aguarda que outros resolvam os problemas ou removam os obstáculos.',
    level1desc: 'Tenta lidar com os obstáculos, mas desiste rapidamente ou escala prematuramente.',
    level2desc: 'Toma a iniciativa de remover obstáculos e encontrar soluções para avançar.',
    level3desc: 'Inspira outros a tomarem a iniciativa e cria um ambiente em que superar bloqueios é uma responsabilidade compartilhada.',
    levelAbbr0: 'Início',
    levelAbbr1: 'Em des.',
    levelAbbr2: 'Consiste.',
    levelAbbr3: 'Referência',
    todayLabel: 'Hoje',
    pointsInMonths: 'pontos em {{n}} meses',
    monthsWithFeedback: 'meses com feedback',
    thisMonth: 'este mês',
    headingToLevel: 'Rumo a {{level}}',
    maxLevel: 'Nível máximo!',
    narrativeStrength: 'O que você mais contribui e merece reconhecimento é <strong>{{fund}}</strong> — você está no nível <strong>{{level}}</strong>.',
    narrativeConsistency: 'Você também demonstra consistência em {{others}}.',
    narrativeProgress: 'Nos últimos 3 meses você avançou — seu perfil mostra crescimento.',
    narrativeStable: 'Seu perfil se manteve estável nos últimos 3 meses — isso fala de consistência.',
    narrativeVariation: 'Seu perfil variou um pouco nos últimos meses. Variações são normais e não definem quem você é.',
    narrativeNextLevel: 'Seu próximo nível de crescimento está em <strong>{{fund}}</strong>. O próximo passo é chegar ao nível {{level}} — abaixo sugerimos uma ação concreta.',
    act01: 'Reconhecimento — como os outros te veem',
    act02: 'Progresso — como você evoluiu',
    act03: 'Direção — seu próximo passo',
    reinforces: 'REFORÇA',
    tryToday: 'Vou tentar hoje',
    committed: 'Estou comprometido hoje!',
    defaultChallenge: 'Pratique um fundamental hoje',
    defaultChallengeDesc: 'Escolha uma micro-ação e coloque em prática na sua próxima reunião.',
    clickDetail: 'Clique para detalhe',
    nextLevel: 'PRÓXIMO NÍVEL',
    growthTitle: 'PARA CONTINUAR CRESCENDO',
    growthSub: 'Recomendações baseadas no seu feedback',
    feedbacks: 'feedbacks',
    peers: 'colegas',
    givenTitle: 'Minha participação dando feedback',
    givenSub: 'Feedback que você compartilhou este mês',
    footerPrivacy: 'Todo o feedback é anônimo. Ninguém pode ver quem te deu. Esta visualização é só sua.',
    footerHeart: 'Lembre-se: feedback é um presente. Esses dados refletem momentos em reuniões, não quem você é.',
    personSingular: 'pessoa',
    personsPlural: 'pessoas',
    trend: {
      up: 'Seu perfil mostra crescimento',
      down: 'Pequena variação — isso é normal',
      stable: 'Perfil estável — isso é consistência',
    },
    empty: {
      title: 'Conheça os Fundamentals',
      desc: 'Você ainda não tem feedback suficiente para mostrar seu dashboard. Enquanto isso, explore os comportamentos que medimos.',
      hint: 'Você precisa de pelo menos 3 avaliações para ativar seu dashboard pessoal. Participe das pesquisas pós-reunião para começar a receber feedback.',
    },
    popup: {
      peersOpined: 'colegas avaliaram',
      subbehaviors: 'Sub-comportamentos',
      monthlyHistory: 'Evolução mensal',
      distribution: 'Distribuição de feedbacks',
      behaviorScale: 'Escala de comportamento',
      you: 'Você',
    },
  },
  admin: {
    title: 'Administração',
    panelTitle: 'Painel Admin',
    roleAdminCentral: 'Admin Central',
    roleAdminOU: 'Admin UA',
    roleEmployee: 'Funcionário',
    greetingMorning: 'Bom dia',
    greetingAfternoon: 'Boa tarde',
    greetingEvening: 'Boa noite',
    surveys: 'Pesquisas',
    templates: 'Templates',
    analyticsTab: 'Analytics',
    rulesTab: 'Regras de Negócio',
    users: 'Usuários',
    notifications: 'Notificações',
    surveysTitle: 'Gestão de Pesquisas',
    searchSurvey: 'Buscar pesquisa...',
    trash: 'Lixeira',
    newSurvey: 'Nova Pesquisa',
    fundamentalsTab: 'Gerais',
    customTab: 'Personalizadas',
    colName: 'Nome',
    colTitle: 'Título',
    colDescription: 'Descrição',
    colQuestions: 'Perguntas',
    colStatus: 'Status',
    colAudience: 'Audiência',
    colFrequency: 'Frequência',
    colFeedback: 'Feedbacks',
    colPeriod: 'Período',
    colActions: 'Ações',
    colCreatedBy: 'Criada por',
    colEmail: 'Email',
    colOU: 'UA',
    colUses: 'usos',
    statusActive: 'Ativa',
    statusPaused: 'Pausada',
    statusInactive: 'Inativa',
    statusPending: 'Pendente',
    anonymous: 'Anônima',
    duplicate: 'Duplicar',
    exportExcelTip: 'Exportar Excel',
    templatesTitle: 'Templates de Pesquisas',
    tipsTab: 'Dicas',
    actionsTab: 'Ações',
    catalogTab: 'Catálogos',
    createTemplate: 'Criar template',
    typeFundamental: 'Fundamental',
    typeCustom: 'Personalizada',
    placeholderTips: 'Dicas — Módulo de conselhos para colaboradores',
    tplSearchPlaceholder: 'Buscar template…',
    tplFilterAll: 'Todos os tipos',
    tplNoResults: 'Nenhum template com esse critério',
    tipsTitle: 'Dicas de Feedback',
    tipsSearchPlaceholder: 'Buscar dica…',
    tipsAllFundamentals: 'Todos os Fundamentais',
    tipsAllTypes: 'Todos os tipos',
    tipTypeReconocer: 'Para Reconhecer',
    tipTypeCrecer: 'Para Crescer',
    tipsNoResults: 'Nenhuma dica com esse critério',
    surveysNoResults: 'Nenhuma pesquisa com esse critério',
    surveysError: 'Erro ao carregar pesquisas. Tente novamente mais tarde.',
    createTip: 'Criar dica',
    actionsTitle: 'Ações de Crescimento',
    actionsSearchPlaceholder: 'Buscar ação…',
    actionsNoResults: 'Nenhuma ação com esse critério',
    createAction: 'Criar ação',
    catalogTitle: 'Catálogo de Fundamentais',
    catalogFundamentals: 'Fundamentais',
    catalogBehaviors: 'Comportamentos',
    catalogAddFundamental: 'Adicionar Fundamental',
    catalogAddBehavior: 'Adicionar Daily Habit',
    catalogSearchFundamental: 'Buscar fundamental…',
    catalogSearchBehavior: 'Buscar daily habit…',
    catalogNoBehaviors: 'Sem daily habits para este fundamental',
    catalogSelectFundamental: 'Selecione um Fundamental da lista',
    ousTab: 'OUs',
    ousTitle: 'Unidades Organizacionais',
    ousSubtitle: 'Gerencie as OUs raiz do tenant',
    ousSearchPlaceholder: 'Buscar OU…',
    ousNoResults: 'Nenhuma OU corresponde a esse critério',
    createOU: 'Criar OU',
    editOU: 'Editar OU',
    deleteOU: 'Excluir OU',
    deleteOUConfirm: 'Excluir OU "{{name}}"? Esta ação não pode ser desfeita.',
    ouDescription: 'Descrição',
    ouAdminUser: 'Admin OU (AAD User ID)',
    ouType: 'Tipo',
    ouGdpr: 'GDPR',
    ouAzureGroupId: 'ID do grupo do Azure AD',
    ouAzureGroupIdHint: 'Vincule esta OU ao seu grupo real no Azure AD para a árvore hierárquica. Deixe vazio se ainda não estiver provisionado.',
    ouAzureGroupIdSelectPlaceholder: '— Selecione um grupo raiz do Azure AD —',
    ouAzureGroupIdLoading: 'Carregando grupos do Azure AD…',
    ouAzureGroupIdRootsError: 'Não foi possível carregar a lista de grupos do Azure AD. Você pode digitar o ID manualmente.',
    ouAzureGroupIdCurrentUnknown: 'Grupo vinculado atual (não aparece na lista)',
    ouAzureGroupIdManualToggle: 'Digitar o ID manualmente',
    ouAzureGroupIdListToggle: 'Escolher da lista',
    ouActivate: 'Ativar OU',
    ouDeactivate: 'Desativar OU',
    ouExpand: 'Expandir',
    ouCollapse: 'Recolher',
    ouSelectPlaceholder: 'Selecionar OU…',
    ouErrorName: 'O nome da OU é obrigatório',
    ouTimezone: 'Fuso Horário',
    ouTimezoneSelect: 'Selecione o fuso horário',
    ouErrorTimezone: 'O fuso horário é obrigatório',
    colFundamental: 'Fundamental',
    colCondition: 'Condição',
    placeholderActions: 'Ações — Planos de ação pós-pesquisa',
    placeholderCatalog: 'Catálogo de Fundamentals — Biblioteca de comportamentos avaliáveis',
    placeholderAnalytics: 'Dashboard unificado de Analytics — Ver visão Executivo para detalhes completos',
    activeUsersLabel: 'Colaboradores ativos',
    avgCulturalScore: 'Score cultural médio',
    participationRateLabel: 'Taxa de participação',
    omissionRateLabel: 'Taxa de omissão',
    thisMonth: 'este mês',
    rulesTitle: 'Regras de Negócio',
    restoreDefaults: 'Restaurar Padrões',
    restoreDefaultsTitle: 'Restaurar configuração padrão',
    restoreDefaultsDesc: 'Todos os valores das regras de negócio serão redefinidos para a configuração original. Esta ação não pode ser desfeita.',
    restoreDefaultsConfirm: 'Sim, restaurar',
    rn001Title: 'Critérios de Reunião',
    rn001Subtitle: 'Define a duração de reuniões que ativam pesquisa',
    rn002Title: 'Regras de Exclusão',
    rn002Subtitle: 'Cenários onde pesquisas NÃO são disparadas',
    rn004Title: 'Limites por Usuário',
    rn004Subtitle: 'Controla a quantidade de pesquisas que cada pessoa recebe',
    rn005Title: 'Limite Diário de Pesquisas',
    rn005Subtitle: 'Número máximo de pesquisas que um usuário pode receber por dia',
    fieldMinSessionDuration: 'Duração mínima da sessão',
    fieldMaxSessionDuration: 'Duração máxima da sessão',
    fieldMinParticipants: 'Mínimo de participantes',
    fieldMaxParticipants: 'Máximo de participantes',
    fieldExclRecurring: 'Excluir reuniões recorrentes',
    fieldExclRecurringSub: 'Não aplicar em reuniões semanais, dailies, etc.',
    fieldExclWorkHours: 'Excluir fora do horário de trabalho',
    fieldExclWorkHoursSub: 'Aplicar apenas dentro do horário configurado por UA',
    fieldMaxSurveysWeek: 'Máximo de pesquisas por semana',
    fieldMaxParticipantsPerSurvey: 'Máximo de participantes a avaliar por pesquisa',
    fieldMinInterval: 'Intervalo mínimo entre pesquisas',
    fieldMaxSurveysDay: 'Máximo de pesquisas por dia por usuário',
    rn005Info: 'Se um usuário já recebeu o máximo de pesquisas no dia, as seguintes são adiadas para o próximo dia útil respeitando a ordem de prioridade configurada.',
    suffixMinutes: 'minutos',
    suffixUsers: 'usuários',
    suffixSurveysWeek: 'pesquisas/semana',
    suffixPersons: 'pessoas',
    suffixHours: 'horas',
    suffixSurveysDay: 'pesquisas / dia',
    customizableByOU: 'Personalizável por UA',
    cancelChanges: 'Cancelar alterações',
    saveConfig: 'Salvar configuração',
    rulesConfig: 'Configuração',
    rulesStatus: 'Status',
    rulesCustom: 'Personalizado',
    rulesSave: 'Salvar',
    rulesCancel: 'Cancelar',
    rulesSchedule: 'Horário',
    rulesInheritsGlobal: '↑ Herda global',
    rulesInherited: 'Herdado',
    rulesGlobal: 'Global',
    rulesPersonalize: 'Personalizar',
    tplCatAll: 'Todos',
    tplCatGeneral: 'Geral',
    tplCatCustom: 'Personalizada',
    usersTitle: 'Gestão de Usuários',
    searchUser: 'Buscar usuário...',
    newUser: 'Novo usuário',
    notificationsTitle: 'Configuração de Notificações',
    notifOmitirTitle: 'Notificação de "PULAR"',
    notifyAfter: 'Notificar após',
    consecutiveOmissions: '"PULAR" consecutivos',
    notifyTo: 'Notificar:',
    notifyUser: 'Usuário',
    notifyDirectManager: 'Gerente direto',
    notifyAdminOU: 'Administrador UA',
    messageForUser: 'Mensagem para o usuário:',
    availableVarsOmitir: 'Variáveis disponíveis: {nombre}, {count}, {fecha}, {manager}',
    europaOmissionsTitle: 'Omissões Europa (BU)',
    manualOnlyGDPR: 'Somente manual — GDPR',
    gdprWarning: 'Devido a regulamentações legais (GDPR), e-mails de omissão para a Europa nunca são enviados automaticamente. O administrador deve redigí-los, revisá-los e enviá-los manualmente.',
    emailTemplateEmployee: 'Modelo de e-mail — funcionário Europa:',
    reviewBeforeSending: 'Revisar e personalizar antes de cada envio.',
    generalNotificationsTitle: 'Notificações Gerais',
    notifMessageLabel: 'Mensagem da notificação:',
    notifMessagePlaceholder: 'Escreva a mensagem que deseja enviar aos colaboradores...',
    notifAudienceLabel: 'Audiência:',
    notifAudienceGlobal: 'Global (excl. Europa)',
    sendNotification: 'Enviar notificação',
    availableVarsGeneral: 'Variáveis disponíveis: {nombre}, {ou}, {fecha}',
    saveChanges: 'Salvar alterações',
    saveTemplates: 'Salvar modelos',
    sidebarExpand: 'Expandir menu',
    sidebarCollapse: 'Recolher menu',
    analyticsComingSoon: 'Painel de Analytics — em desenvolvimento. Consulte a visão Executiva para detalhes.',
    colType: 'Tipo',
    tplCategory: 'Categoria',
    tplQuestions: 'perguntas',
    tplUse: 'Usar',
    tplDeleteTitle: 'Excluir template',
    tplDeleteDesc: 'Excluir "{{name}}"? Esta ação não pode ser desfeita.',
    tipDeleteTitle: 'Excluir tip',
    tipDeleteDesc: 'Excluir "{{name}}"? Esta ação não pode ser desfeita.',
    tipEditTitle: 'Editar dica',
    tipAddTitle: 'Adicionar dica',
    tipFormFundamental: 'Fundamental',
    tipFormSelectFundamental: 'Selecione um fundamental…',
    tipFormDailyHabit: 'Daily Habit vinculado',
    tipFormSelectDailyHabit: 'Selecione um Daily Habit…',
    tipFormOperator: 'Operador',
    tipFormThreshold: 'Limiar %',
    tipFormMax: 'Máx %',
    tipFormType: 'Tipo de dica',
    tipFormName: 'Nome da dica',
    tipFormNamePlaceholder: 'Ex. Aprendizado Destacado',
    tipFormText: 'Texto da dica',
    tipFormTextPlaceholder: 'Mensagem que o colaborador verá…',
    tipFormActivationRule: 'Condição de resultado',
    tipFormActive: 'Ativo',
    tipFormPreview: 'Pré-visualização',
    tipRangeMin: 'Limite mínimo',
    tipRangeMax: 'Limite máximo',
    tipHintCondition: 'Score médio do fundamental (0–100). Ex: de 0 a 40 ativa o tip em resultados baixos.',
    tipHintBehavior: 'Comportamento específico ao qual este tip se aplica.',
    tipFieldObserved: 'Texto observado',
    tipTagGreen: 'caixa verde clara',
    tipTagDark: 'caixa escura',
    tipTagBlue: 'caixa Próximo Nível',
    tipHintObserved: 'O que os colegas observam. Aparece em itálico no painel de conquistas.',
    tipFieldGrowthSuggestion: 'Sugestão de Crescimento',
    tipHintGrowthSuggestion: 'Sugestão acionável que aparece junto ao reconhecimento.',
    tipFieldLevelName: 'Nome do nível',
    tipLevelNamePlaceholder: 'Ex. Impulso Necessário, Em Construção…',
    tipCrecerPairedPlaceholder: 'Ex. Mencione o consumidor: Na sua próxima decisão, pergunte…',
    tipTranslations: 'Traduções',
    tipAddLang: '+ Adicionar:',
    tipPreviewContext: 'É assim que aparecerá no painel do colaborador:',
    tipSave: 'Salvar tip',
    tipSaveError: 'Para salvar, preencha os seguintes campos:',
    colContent: 'Conteúdo',
    colActive: 'Ativo',
    opGte: 'maior ou igual',
    opLte: 'menor ou igual',
    opGt: 'maior que',
    opLt: 'menor que',
    opBetween: 'Entre (intervalo)',
    actionEditTitle: 'Editar ação',
    actionNewTitle: 'Nova ação',
    actionFormTitle: 'Título da ação',
    actionFormTitlePlaceholder: 'Ex. Proponha uma ação concreta',
    actionFormDescription: 'Descrição completa',
    actionFormDescPlaceholder: 'Descrição da ação…',
    actionActivationRule: 'Regra de ativação',
    actionActivationRuleHint: 'Pontuação média do fundamental (1–4). Define o intervalo que ativa esta ação.',
    actionRuleMin: 'Limite mínimo',
    actionRuleMax: 'Limite máximo',
    actionRangeLabel: 'Intervalo',
    actionNextLevelText: 'Texto "Próximo Nível"',
    actionNextLevelHint: 'Aparece na caixa azul do cartão.',
    actionNextLevelPlaceholder: 'Ex. Para chegar ao próximo nível, concentre-se em…',
    actionPreview: 'Pré-visualização',
    actionPreviewEmpty: 'Preencha o formulário para ver a pré-visualização',
    actionTranslations: 'Traduções',
    actionTransComplete: 'Tradução completa',
    actionTransMissing: 'Tradução incompleta',
    actionPreviewContext: 'Assim aparecerá no painel do colaborador:',
    actionFormDescHint: 'Exibido ao abrir a ação.',
    actionSave: 'Salvar ação',
    actionSaveError: 'Para salvar, complete os seguintes campos:',
    actionDeleteTitle: 'Excluir ação',
    actionDeleteDesc: 'Excluir "{{name}}"? Esta ação não pode ser desfeita.',
    fundEditTitle: 'Editar Fundamental',
    fundNewTitle: 'Novo Fundamental',
    fundFormFullName: 'Nome completo',
    fundFormFullNamePlaceholder: 'Ex. Mindset & Behavior - Learner',
    fundFormShortName: 'Nome curto',
    fundFormShortNamePlaceholder: 'Ex. Learner',
    fundFormDescription: 'Descrição',
    fundFormDescriptionPlaceholder: 'Breve descrição deste fundamental...',
    fundFormIcon: 'Ícone',
    fundFormColor: 'Cor',
    fundFormUrl: 'URL de referência',
    fundFormUrlPlaceholder: 'https://...',
    fundFormLanguage: 'Idioma',
    fundFormAllLangsRequired: 'Preencha o nome completo, nome curto e descrição nos 7 idiomas para poder salvar.',
    behEditTitle: 'Editar Daily Habit',
    behNewTitle: 'Novo Daily Habit',
    behFormName: 'Nome do Daily Habit',
    behFormNamePlaceholder: 'Ex. Humility & Openness',
    behFormAllLangsRequired: 'Preencha o nome nos 7 idiomas para poder salvar.',
    behFormFundamental: 'Fundamental vinculado',
    behFormIntro: 'Introdução / contexto de avaliação',
    behFormIntroPlaceholder: 'Ex. Nesta reunião, esta pessoa…',
    behFormRoles: 'Funções aplicáveis',
    behFormRolesHint: 'A quem este Daily Habit se aplica?',
    fundDeleteTitle: 'Excluir fundamental',
    fundDeleteDesc: 'Excluir "{{name}}"? Esta ação não pode ser desfeita.',
    behDeleteTitle: 'Excluir Daily Habit',
    behDeleteDesc: 'Excluir "{{name}}"? Esta ação não pode ser desfeita.',
    imageUploadSelect: 'Enviar imagem',
    imageUploadChange: 'Alterar imagem',
    imageUploadInvalidFormat: 'Formato não suportado. Use PNG, JPG, WEBP ou SVG.',
    imageUploadTooLarge: 'O arquivo excede o tamanho máximo permitido (2 MB).',
    fundFormImage: 'Imagem',
    attNewTitle: 'Nova Atitude e Comportamento',
    attEditTitle: 'Editar Atitude e Comportamento',
    attFormName: 'Nome da Atitude e Comportamento',
    attFormNamePlaceholder: 'Ex. Colaboração ativa',
    attFormDescription: 'Descrição da Atitude e Comportamento',
    attFormDescriptionPlaceholder: 'Breve descrição desta atitude e comportamento...',
    attFormAllLangsRequired: 'Preencha o nome nos 7 idiomas para salvar.',
    attFormImage: 'Imagem',
    attDeleteTitle: 'Excluir Atitude e Comportamento',
    attDeleteDesc: 'Excluir "{{name}}"? Os Daily Habits também serão desativados.',
    catalogAttitudesLabel: 'atitudes e comportamentos',
    catalogSelectAttitude: 'Selecione uma Atitude e Comportamento da lista',
    catalogBackToFundamentals: 'Voltar aos Fundamentals',
    catalogBackToAttitudes: 'Voltar às Atitudes e Comportamentos',
    catalogGroupWithAttitudes: 'Agrupar em Atitudes e Comportamentos',
    catalogNoFundamentals: 'Sem fundamentais',
    madurezEditTitle: 'Editar níveis de Maturidade Cultural',
    madurezFrameworkTitle: 'Maturidade Cultural — Estrutura de níveis',
    nivelesAdopcionTitle: 'Etapas de adoção de um Daily Habit — Estrutura de níveis',
    nivelesAdopcionEditTitle: 'Editar etapas de adoção de um Daily Habit',
    madurezLabelPlaceholder: 'Rótulo',
    audienceGlobal: 'Global (excl. Europa)',
    audienceMexico: 'México',
    audienceLATAM: 'LATAM',
    audienceUSA: 'EUA',
    audienceFOSE: 'FOSE',
    rn000Title: 'Desativar App por UO',
    rn000Subtitle: 'Desativa completamente o Sigma Pulse para uma ou mais unidades organizacionais.',
    rn000Warning: 'Ao desativar uma UO, todos os seus colaboradores param de receber pesquisas imediatamente. Os dados históricos são preservados.',
    rn003Title: 'Horário de Trabalho por UO',
    rn003Subtitle: 'Horário em que as pesquisas são aplicadas (hora local)',
    rn003GlobalDefault: 'Horário global padrão',
    rn003GlobalNote: 'Aplica-se a todas as UOs sem horário personalizado.',
    rn003TimeConnector: 'às',
    ouActive: 'Ativa',
    ouDisabled: 'Desativada',
    rn002KwLabel: 'Excluir somente se o nome contém:',
    rn002KwHint: '(vazio = todas as recorrentes)',
    rn002KwPlaceholder: 'Adicionar palavra-chave...',
    usersAdminTitle: 'Gestão de Administradores',
    addAdmin: 'Adicionar Administrador',
    editAdmin: 'Editar Administrador',
    newAdmin: 'Novo Administrador',
    adminEmail: 'Endereço de e-mail',
    adminEmailInvalid: 'Insira um endereço de e-mail válido (ex. nome@dominio.com)',
    adminRole: 'Função',
    adminRolePlaceholder: 'Selecione uma função...',
    adminOU: 'Unidade Operacional (UO)',
    adminOUPlaceholder: 'Selecione uma UO...',
    adminOUAll: 'Todas (acesso completo à UO)',
    adminBU: 'Unidade de Negócios (BU) — opcional',
    adminBUPlaceholder: 'Toda a UO (sem restrição)',
    adminBUHint: 'Se nenhuma BU for selecionada, o admin gerencia toda a UO.',
    colUser: 'Usuário',
    colAlcance: 'Escopo',
    colPermisos: 'Permissões',
    colEstado: 'Status',
    permGlobalTitle: 'Admins UO/BU podem criar pesquisas',
    permGlobalDesc: 'Quando ativo, todos os Admins UO/BU podem criar e enviar pesquisas.',
    permEnabled: 'Ativado',
    permDisabled: 'Desativado',
    permCreateSurveys: 'Criar pesquisas',
    permViewAnalytics: 'Ver Analytics',
    permManageUsers: 'Gerenciar Usuários',
    permApproveSurveys: 'Aprovar pesquisas',
    userDeleteTitle: 'Excluir administrador',
    userDeleteDesc: 'Excluir "{{name}}"? Esta ação não pode ser desfeita.',
    noUsersFound: 'Sem resultados',
    adminCount: 'administradores',
    messageForManager: 'Mensagem para o manager:',
    emailTemplateManager: 'Modelo de e-mail — manager Europa:',
    notifOUPersonalization: 'Personalização por UO',
    addOUPersonalization: 'Adicionar personalização',
    europaNoAutoSend: 'Esses e-mails não são enviados automaticamente.',
    europaActivateTitle: 'Ativar notificações Europa?',
    europaActivateDesc: 'As notificações de omissões para a Europa estão sujeitas a regulamentos GDPR estritos. Ao ativar esta seção você confirma que tem autorização do responsável de privacidade da UO Europa e que os e-mails serão enviados manualmente com revisão prévia.',
    europaActivateConfirm: 'Sim, ativar com responsabilidade',
    includeEuropa: 'Incluir Europa (BU)',
    includeEuropaHint: 'requer revisão GDPR antes do envio',
    europaSectionDisabled: 'Seção desativada — ative o switch para configurar',
    ouPersonalizedSingular: 'OU personalizada',
    ouPersonalizedPlural: 'OUs personalizadas',
    notifCustomUserMsgPlaceholder: 'Mensagem personalizada para o usuário…',
    notifCustomMgrMsgPlaceholder: 'Mensagem personalizada para o manager…',
    kwRemove: 'Remover',
    kwAdd: 'Adicionar',
    permissions: 'Permissões',
    rules: 'Regras de negócio',
    catalog: 'Catálogo',
    createUser: 'Criar usuário',
    editUser: 'Editar usuário',
    deleteUser: 'Excluir usuário',
    roles: 'Função',
    organizationalUnit: 'Unidade Organizacional',
    minDuration: 'Duração mínima (min)',
    maxDuration: 'Duração máxima (min)',
    minParticipants: 'Participantes mínimos',
    maxPerDay: 'Máx. avaliações por dia',
    maxPerWeek: 'Máx. avaliações por semana',
    omissionThreshold: 'Limite de omissões',
    columns: 'Colunas',
    colPickerTitle: 'Colunas visíveis',
    colPickerReset: 'Redefinir',
    pagerRowsPerPage: 'Linhas por página',
    pagerOf: 'de',
    confirmMoveToTrash: 'Mover para lixeira?',
    confirmMoveToTrashMsg: 'A pesquisa será movida para a lixeira e excluída permanentemente após 30 dias. Você pode restaurá-la antes desse prazo.',
    confirmMoveBtn: 'Mover para lixeira',
    confirmDeleteForeverTitle: 'Excluir permanentemente?',
    confirmDeleteForeverMsg: 'Esta ação é irreversível. A pesquisa e todos os seus dados serão excluídos para sempre.',
    confirmDeleteForeverBtn: 'Excluir para sempre',
    trashTitle: 'Lixeira de pesquisas',
    trashSubtitle: 'As pesquisas são excluídas permanentemente após 30 dias',
    trashEmpty: 'A lixeira está vazia',
    trashRestore: 'Restaurar',
    trashDaysLeft: 'dias restantes',
    colSurvey: 'Pesquisa',
    trashResponses: 'resp.',
    trashTimeLeft: 'Tempo restante',
    trashDeletedBy: 'Excluído por',
    trashDeletedAt: 'Data de exclusão',
    trashDays: 'dias',
    trashExpiresTODAY: 'Expira hoje',
    filterAll: 'Todos',
    filterSearchName: 'Buscar nome…',
    filterSearchCreator: 'Buscar criador…',
    filterFrom: 'De',
    filterTo: 'Até',
    filterClearDates: 'Limpar datas',
    pauseSurvey: 'Pausar',
    activateSurvey: 'Ativar',
    builderNewTitle: 'Nova Pesquisa',
    builderEditTitle: 'Editar Pesquisa',
    builderNewTemplateTitle: 'Novo Template',
    builderEditTemplateTitle: 'Editar Template',
    builderBackToSurveys: 'Voltar às pesquisas',
    builderSaveDraft: 'Salvar rascunho',
    builderPublish: 'Publicar pesquisa',
    builderStep1: 'Informações Básicas',
    builderStep2: 'Audiência e Frequência',
    builderStep3: 'Perguntas',
    builderStep4: 'Revisão',
    builderPreview: 'Pré-visualização',
    builderName: 'Nome da pesquisa',
    builderNamePlaceholder: 'Ex: Avaliação Pós-Reunião Q2',
    builderDescription: 'Descrição',
    builderDescriptionPlaceholder: 'Descreva o propósito desta pesquisa…',
    builderApproach: 'Abordagem',
    builderApproachIndividual: 'Individual',
    builderApproachCollective: 'Coletivo',
    builderAnonymous: 'Avaliação anônima',
    builderAnonymousSub: 'Os avaliados não saberão quem os avaliou',
    dayMon: 'Segunda-feira', dayTue: 'Terça-feira', dayWed: 'Quarta-feira', dayThu: 'Quinta-feira',
    dayFri: 'Sexta-feira', daySat: 'Sábado', daySun: 'Domingo',
    dayMonShort: 'Seg', dayTueShort: 'Ter', dayWedShort: 'Qua', dayThuShort: 'Qui',
    dayFriShort: 'Sex', daySatShort: 'Sáb', daySunShort: 'Dom',
    dayLetterMon: 'S', dayLetterTue: 'T', dayLetterWed: 'Q', dayLetterThu: 'Q',
    dayLetterFri: 'S', dayLetterSat: 'S', dayLetterSun: 'D',
    activeDaysAll: 'A pesquisa estará ativa a semana toda',
    activeDaysPrefix: 'A pesquisa estará ativa em:',
    activeDaysNone: 'Nenhum dia selecionado',
    workdays: 'Dias úteis',
    builderExitTitle: 'Sair do editor?',
    builderExitDesc: 'As alterações não salvas serão perdidas se você sair agora.',
    builderExitCancel: 'Continuar editando',
    builderExitConfirm: 'Sim, sair',
    builderValidationTitle: 'Campos obrigatórios',
    builderValidationDesc: 'Por favor preencha os seguintes campos antes de continuar:',
    builderValidationClose: 'Entendido',
    builderValidationName: 'Identificador Interno',
    builderValidationSurveyType: 'Tipo de pesquisa',
    builderValidationStartDate: 'Data de início',
    builderValidationEndDate: 'Data de término',
    builderValidationDateRange: 'A data de término não pode ser anterior à data de início',
    builderValidationActiveDays: 'Pelo menos um dia de ativação',
    builderValidationMeetingId: 'Informe o ID do Meeting',
    builderValidationPeople: 'Selecione pelo menos uma pessoa',
    builderValidationOU: 'Selecione pelo menos uma OU',
    builderValidationNoQuestions: 'Você deve adicionar pelo menos uma pergunta para continuar. Não é possível criar pesquisas sem perguntas.',
    builderValidationMinParticipants: 'O mínimo de participantes deve ser pelo menos 1',
    builderValidationMaxParticipants: 'O máximo de participantes deve ser pelo menos 1',
    builderValidationParticipantsRange: 'O mínimo de participantes não pode ser maior que o máximo',
    builderValidationTranslations: 'Traduções incompletas',
    // Builder new keys
    builderCloseEditor: 'Fechar editor',
    builderPrevious: 'Anterior',
    builderNext: 'Próximo',
    builderSaveTemplate: 'Salvar como template',
    builderInternalId: 'Identificador interno',
    builderInternalIdHint: 'Visível apenas para administradores — os colaboradores não veem este nome ao responder',
    builderSurveyTypeStar: 'Tipo de pesquisa',
    builderTypeGeneral: 'Geral',
    builderTypeGeneralDesc: 'Regido por regras de negócio. Disparado automaticamente após reuniões.',
    builderTypePersonalized: 'Personalizada',
    builderTypePersonalizedDesc: 'Vinculada a uma sessão específica do Teams por Meeting ID.',
    builderPeriod: 'Período da pesquisa',
    builderStartLabel: 'Início',
    builderEndLabel: 'Fim',
    builderPeriodHint: 'A pesquisa será ativada na data de início e desativada automaticamente ao terminar',
    builderActiveDaysLabel: 'Dias de ativação',
    builderCustomTag: 'Personalizado',
    builderAudienceSectionTitle: 'Audiência',
    builderWhoApplies: 'A quem se aplica esta pesquisa?',
    builderSelectOneOrMoreOUs: 'Selecione uma ou mais UAs',
    builderGlobal: 'Global',
    builderGlobalDesc: 'Todas as UAs e BUs',
    builderExcludesEurope: 'exclui Europa',
    builderGlobalAdminOUAccess: 'Administrador Global — você tem acesso a todas as UAs do sistema.',
    builderLegalRegulation: 'Regulação legal — sempre campo separado',
    builderEurope: 'Europa (BU)',
    builderGDPRTag: 'GDPR — Regulação legal',
    builderEuropeExcludedNote: 'A Europa nunca é incluída em campanhas Globais nem multi-UA por cumprimento legal.',
    builderEuropaAuthNote: 'Lembre-se de obter autorização da UA Europa antes de enviar pesquisas para esta região.',
    builderAudienceCustomTitle: 'Destinatários',
    builderAudienceCustomSubtitle: 'Defina quem receberá esta pesquisa personalizada.',
    builderRecipientsLabel: 'Destinatários',
    builderByMeetingId: 'Por Meeting ID',
    builderByPeople: 'Pessoas específicas',
    builderByOU: 'Por organograma (UA)',
    audienceTypeMeeting: 'Meeting',
    audienceTypePeople: 'Pessoas',
    audienceTypeOU: 'UA',
    builderMeetingIdHint: 'Será aplicado a todos os participantes daquela sessão do Teams',
    builderSelectPeople: 'Selecione pessoas da lista',
    builderAllOUs: 'Todas as UAs',
    builderAllAvailableAdded: 'Todos os disponíveis já foram adicionados',
    builderSearchPeoplePlaceholder: 'Buscar pessoa pelo nome…',
    builderLoadingPeople: 'Carregando pessoas…',
    builderErrorLoadingPeople: 'Não foi possível carregar a lista de pessoas. Tente novamente.',
    builderPersonSelected: 'pessoa selecionada',
    builderPeopleSelected: 'pessoas selecionadas',
    builderSelectOU: 'Selecione uma UA...',
    builderSelectOUForTeam: 'Selecione uma UA para ver seus colaboradores',
    builderQuestionsTitle: 'Perguntas',
    builderEuropaQuestionsNote: 'Modo Europa: pesquisa livre, sem vinculação a Fundamentals. Apenas perguntas sobre a reunião.',
    builderQuestionsApplyToAll: 'Cada pergunta se aplica a cada participante da reunião.',
    builderFilterAll: 'Todos',
    builderNoQuestions: 'Ainda não há perguntas',
    builderNoQuestionsHint: 'Clique em "+ Adicionar pergunta" para começar',
    builderNoQuestionsOfType: 'Sem perguntas deste tipo',
    builderAddQuestion: '+ Adicionar pergunta',
    builderQuestionLabel: 'Pergunta',
    builderDeleteQuestion: 'Excluir',
    builderApproachLabel: 'Abordagem',
    builderIndividualSub: 'Avalia cada participante',
    builderCollectiveSub: 'Para a sessão em geral',
    builderPresentationMode: 'Modo de apresentação',
    builderMatrix: 'Matriz Geral',
    builderMatrixSub: 'Pergunta sobre a reunião ou tema geral',
    builderIndividualCard: 'Individual',
    builderIndividualCardSub: 'Um cartão por pessoa',
    builderTypeLabel: 'Tipo',
    builderFundamentalLabel: 'Fundamental',
    builderSelectFundamental: 'Selecione um Fundamental...',
    builderDailyHabitLabel: 'Daily Habit',
    builderSelectDailyHabit: 'Selecione um Daily Habit...',
    builderQuestionText: 'Texto da pergunta',
    builderQuestionTextPlaceholder: 'Escreva a pergunta aqui',
    builderIconLabel: 'Ícone',
    builderOptional: '(opcional)',
    builderChangeIcon: 'Alterar',
    builderSelectIconBtn: 'Selecionar ícone',
    builderOptionsLabel: 'Opções (máx. 4 + "Não Observável")',
    builderNoObservable: 'Não Observável',
    builderRemoveNoObs: 'Remover Não Observável',
    builderAddNoObs: 'Adicionar "Não Observável"',
    builderAddOption: 'Adicionar Opção',
    builderMaxOptions: 'Máximo de 4 opções atingido',
    builderNPSInfo: 'NPS: escala de 0 a 10. Pergunta livre, sem atribuição a participantes.',
    builderOpenInfo: 'Espaço livre para o avaliador escrever sua resposta.',
    builderCampaignWeight: 'Peso de campanha',
    builderAdminGlobalOnly: 'Somente Admin Global',
    builderCampaignWeightSub: 'Maior peso = maior prioridade quando há várias pesquisas ativas. Somente o Admin Global pode modificá-lo.',
    builderWeightBase: 'Peso base (1–10)',
    builderWeightVeryLow: 'Muito Baixa',
    builderWeightLow: 'Baixa',
    builderWeightMedium: 'Média',
    builderWeightHigh: 'Alta',
    builderWeightVeryHigh: 'Muito Alta',
    builderBoostUrgent: 'Boost urgente',
    builderBoostUrgentSub: 'Eleva esta pesquisa acima de todas as outras temporariamente',
    builderBoostDays: 'dias',
    builderBoostActiveDays: 'dia',
    builderBoostActiveMsg: 'Boost ativo — esta pesquisa terá prioridade máxima por',
    builderNoBoostMsg: 'Sem boost ativo — prioridade conforme peso base',
    builderParticipantsTitle: 'Participantes a avaliar',
    builderParticipantsSub: 'Defina quantas pessoas são avaliadas por pesquisa. Mínimo para anonimato e máximo para não sobrecarregar.',
    builderMinParticipantsLabel: 'Mínimo de participantes',
    builderMinParticipantsHint: 'Mín. para garantir anonimato',
    builderMaxParticipantsLabel: 'Máximo de participantes',
    builderMaxParticipantsHint: 'Máx. pessoas a avaliar por pesquisa',
    builderPrivacyTitle: 'Privacidade e anonimato',
    builderPrivacySub: 'Defina se os feedbacks serão associados à identidade do respondente.',
    builderEnableAnonymity: 'Ativar anonimato',
    builderAnonymityDesc: 'Os feedbacks não incluirão o nome do usuário — apenas a resposta e o horário',
    builderTranslationsTitle: 'Traduções',
    builderTranslationsEuropeSub: 'Audiência Europa — os 6 idiomas são obrigatórios. Use o toggle para ativar ou desativar um idioma.',
    builderTranslationsSub: 'A tradução para o Inglês é obrigatória como mínimo. Use o toggle para ativar idiomas adicionais.',
    builderAutoTranslateNote: 'As traduções são geradas automaticamente com o Azure Translator. Revise e ajuste cada campo conforme necessário.',
    builderLangNotApplicable: 'Não aplicável',
    builderLangComplete: 'Concluído',
    builderLangPending: 'Pendente',
    builderLangRequired: 'Obrigatório',
    builderAutoTranslateBtn: 'Traduzir auto.',
    builderLangApplies: 'Aplica',
    builderLangDoesNotApply: 'Não aplica',
    builderTrlName: 'Nome:',
    builderTrlDesc: 'Descrição:',
    builderTrlEmpty: 'vazio',
    builderLangDisabled: 'Este idioma está desativado para esta pesquisa.',
    builderReviewTitle: 'Revisar e publicar',
    builderReviewTemplateTitle: 'Revisar modelo',
    builderEuropaPublishNote: 'Modo Europa: campanha independente por GDPR. Lembre-se de obter autorização da UA Europa.',
    builderPublishIdLabel: 'Identificador',
    builderPublishInternal: '(interno)',
    builderPublishTypeLabel: 'Tipo',
    builderPublishAudienceLabel: 'Audiência',
    builderPublishQuestionsLabel: 'Perguntas',
    builderPublishActiveDaysLabel: 'Dias ativos',
    builderPublishExpirationLabel: 'Expiração',
    builderPublishAnonymityLabel: 'Anonimato',
    builderPublishAnonymousVal: 'Anônima',
    builderPublishNominalVal: 'Nominal',
    builderCompleteBeforePublish: 'Complete antes de publicar:',
    builderCompleteBeforeSave: 'Complete antes de salvar:',
    builderReadyToPublish: 'Tudo pronto. Clique em Publicar Pesquisa para ativá-la.',
    builderReadyToSaveTemplate: 'Tudo pronto. Clique em Salvar Modelo para salvá-lo.',
    builderIconCatalogTitle: 'Catálogo de ícones',
    builderSystemIcons: 'Ícones do sistema',
    builderNoIcon: 'Sem ícone',
    builderMyCatalog: 'Meu catálogo',
    builderDeleteFromCatalog: 'Excluir do catálogo',
    builderCatalogEmpty: 'Seu catálogo está vazio — envie um ícone e salve-o aqui',
    builderUploadIcon: 'Enviar novo ícone',
    builderIconNamePlaceholder: 'Nome do ícone (ex. Inovação)',
    builderSelectFile: 'Selecionar arquivo',
    builderInvalidFormat: 'Formato inválido. Use SVG ou PNG com fundo transparente.',
    builderFileTooLarge: 'Arquivo muito grande. Máximo 200 KB.',
    builderCustomIcon: 'Ícone personalizado',
    builderSaveForReuse: 'Salvar no catálogo para reutilizar',
    builderUseIcon: 'Usar ícone',
    builderIconHelp: 'SVG ou PNG, fundo transparente, 512×512 px recomendado, máx. 200 KB',
    builderPreviewCompleteStep1: 'Complete os dados do Passo 1 para ver a pré-visualização',
    builderPreviewClickToEdit: 'Clique em qualquer texto para editar',
    builderPreviewNoQuestions: 'As perguntas aparecerão aqui no Passo 3',
    builderPreviewGeneral: 'Geral',
    builderPreviewPersonalized: 'Personalizada',
    builderPreviewPulsoEspecifica: 'Pulso Específico',
    builderPreviewChangeIcon: 'Alterar ícone',
    builderPreviewIndividual: 'Individual',
    builderPreviewCollective: 'Coletivo',
    builderPreviewModeIndividual: 'Individual',
    builderPreviewModeMatrix: 'Matriz Geral',
    builderPreviewMissingTranslation: '(sem tradução)',
    builderPreviewWriteAnswer: 'Escreva sua resposta aqui...',
    builderPreviewNoObs: 'Não Observável',
    builderPreviewNA: 'N/A',
    builderNavInfo: 'Info',
    builderNavAudiencia: 'Público',
    builderNavPreguntas: 'Perguntas',
    builderNavConfig: 'Configuração',
    builderNavPublicar: 'Publicar',
    builderNavGuardar: 'Salvar',
    builderInfoTitle: 'Informações básicas',
    builderSelectAll: 'Selecionar tudo',
    langEn: 'Inglês',
    langDe: 'Alemão',
    langPt: 'Português',
    langFr: 'Francês',
    langNl: 'Holandês',
    langRo: 'Romeno',
    builderTrlPlaceholderIn: 'em',
    builderTrlPlaceholderOpt: 'Opção',
    builderTrlNoText: 'Sem texto ainda',
    // New keys added during refactor
    builderLinkedTo: 'Vinculado a',
    builderSelectedIcon: 'Selecionado',
    builderHidePreview: 'Ocultar pré-visualização',
    builderShowPreview: 'Mostrar pré-visualização',
    builderPreviewMorePersons: 'pessoas mais',
    builderPreviewOption1: 'Opção 1',
    builderPreviewOption2: 'Opção 2',
    builderPreviewViewIn: 'Ver em:',
    builderFromOU: 'de',
    builderWillReceiveSurvey: 'receberão esta pesquisa',
    builderPersonsCount: 'pessoas',
    builderPersonsPlural: 'pessoas',
    builderPersonSingular: 'pessoa',
    builderInternalIdPlaceholder: 'Ex: Fundamentos T1 2026',
    builderMeetingIdPlaceholder: 'Ex: 19:meeting_abc123@thread.v2',
    builderOptionDefault: 'Opção',
    builderRemovePerson: 'Remover',
    builderSaveTemplateMock: 'Salvo como template ✓',
    builderPublishGlobalLabel: 'Global (excl. Europa)',
    builderTypeRating: 'Avaliação (1-4)',
    builderTypeMultiple: 'Múltipla Escolha',
    builderTypeOpen: 'Pergunta Aberta',
    builderTypeBehaviors: 'Comportamentos',
    builderTypeNPS: 'NPS (1-10)',
    // System tab
    systemTab: 'Sistema',
    // Monitor tab
    monitorTab: 'Monitoramento',
    // Jobs tab
    jobsTab: 'Jobs',
  },
  jobs: {
    title: 'Jobs de Sincronização AD',
    subtitle: 'Status, histórico e execução manual dos jobs que sincronizam OUs e usuários do Azure AD.',
    ouCatalogSync: 'Sincronização de OUs',
    userCatalogSync: 'Sincronização de Usuários',
    statusNeverRun: 'Nunca executado',
    statusRunning: 'Executando…',
    statusSuccess: 'Sucesso',
    statusSkipped: 'Ignorado',
    statusFailed: 'Erro',
    lastRun: 'Última execução',
    duration: 'Duração',
    triggerScheduled: 'Automático',
    triggerManual: 'Manual',
    created: 'Criados',
    updated: 'Atualizados',
    unchanged: 'Sem alterações',
    skipReason: 'Motivo',
    errorMessage: 'Erro',
    nextScheduled: 'Próxima execução automática',
    nextScheduledUnknown: 'Será calculada após a primeira execução',
    runNow: 'Executar agora',
    runningDisabled: 'Já está em execução',
    viewHistory: 'Ver histórico',
    hideHistory: 'Ocultar histórico',
    historyEmpty: 'Ainda não há execuções registradas.',
    historyLoading: 'Carregando histórico…',
    historyError: 'Não foi possível carregar o histórico.',
    colDate: 'Data',
    colTrigger: 'Disparo',
    colStatus: 'Status',
    colDuration: 'Duração',
    colDetail: 'Detalhe',
    triggerError: 'Não foi possível executar o job.',
    triggerConflict: 'O job já está em execução — aguarde terminar.',
  },
  monitor: {
    title: 'Monitor de Pipeline',
    subtitle: 'Auditoria de elegibilidade por reunião: regras avaliadas, participantes excluídos e amostragem aplicada.',
    refresh: 'Atualizar',
    loading: 'Carregando eventos…',
    lastFetch: 'Atualizado',
    timeout: 'Timeout (10s) — MeetingService não respondeu.',
    unknownError: 'Erro desconhecido',
    empty: 'Sem eventos de pipeline. Processe ou simule uma reunião para ver os registros.',
    eligible: 'Elegível',
    ineligible: 'Não elegível',
    excluded: 'Excluído',
    sampled: 'Amostrado',
    samplingApplied: 'Amostragem aplicada',
    noParticipants: 'Sem detalhes de participantes.',
    statTotal: 'Reuniões processadas',
    statEligible: 'Reuniões elegíveis',
    statAvgSampled: 'Média amostrada',
    statAvgSampledSub: 'por reunião elegível',
    statSampling: 'Amostragem aplicada',
    statSamplingSub: 'reuniões com maxPax ativo',
    colMeetingId: 'ID Reunião',
    colDate: 'Data',
    colDuration: 'Duração',
    colEvaluated: 'Avaliados',
    colEligible: 'Elegíveis',
    colSampled: 'Amostrados',
    colMaxPax: 'Amostragem',
    colResult: 'Resultado',
    colUserId: 'Usuário',
    colOu: 'OU',
    colTimezone: 'Fuso Horário',
    colToday: 'Hoje',
    colWeek: 'Semana',
    colInterval: 'Intervalo',
    colStatus: 'Estado',
    colReason: 'Motivo',
    colSample: 'Pesquisa',
    instancesTitle: 'Pesquisas atribuídas',
    instancesBtnTitle: 'Ver pesquisas deste participante',
    instancesLoading: 'Carregando pesquisas…',
    instancesEmpty: 'Sem instâncias de pesquisa para este participante nesta reunião.',
    instancesSurvey: 'Pesquisa',
    instancesStatus: 'Status',
    instancesExpires: 'Expira',
    instancesDownload: 'Baixar JSON',
    instancesClose: 'Fechar',
    sortAsc: 'Ordenar ascendente',
    sortDesc: 'Ordenar descendente',
    recalculate: 'Recalcular respostas',
    recalculateTitle: 'Recalcular contagem de respostas em todas as pesquisas',
    recalculateSuccess: 'Recálculo concluído: {{count}} pesquisa(s) atualizada(s).',
    recalculateError: 'Erro ao recalcular respostas.',
    cacheTitle: 'Cache do catálogo de OUs',
    cacheLoading: 'Consultando cache…',
    cacheError: 'Não foi possível obter o status do cache de OUs.',
    cachePopulated: 'Preenchido',
    cacheNotPopulated: 'Não preenchido',
    cacheOuCount: 'OUs em cache',
    cacheLastSynced: 'Última sincronização',
    cacheNeverSynced: 'Nunca sincronizado',
  },
  system: {
    title: 'Diagnóstico do Sistema',
    subtitle: 'Status em tempo real de todos os microsserviços e workers do backend.',
    refreshAll: 'Atualizar tudo',
    refresh: 'Atualizar',
    lastChecked: 'Última verificação',
    checking: 'Verificando…',
    never: 'Nunca',
    statusHealthy: 'Saudável',
    statusDegraded: 'Degradado',
    statusError: 'Erro de conexão',
    showDetails: 'Ver verificações',
    hideDetails: 'Ocultar verificações',
    legendTitle: 'Glossário de estados',
    legendHealthyDesc: 'Todas as verificações internas do serviço responderam corretamente.',
    legendDegradedDesc: 'O serviço responde mas MongoDB, Redis ou Service Bus reportaram erro.',
    legendErrorDesc: 'Não foi possível alcançar o serviço a partir do frontend (timeout, CORS ou serviço inativo).',
    checkMongodb: 'MongoDB',
    checkRedis: 'Redis',
    checkServiceBus: 'Service Bus',
    checkSubscriptions: 'Assinaturas',
    activeMessages: 'Mensagens ativas',
    deadLetterMessages: 'Dead Letter',
    environment: 'Ambiente',
    version: 'Versão',
    workers: 'Workers',
    workersDesc: 'Status inferido a partir das assinaturas do Service Bus.',
    analyticsWorker: 'Analytics Worker',
    expirationWorker: 'Expiration Worker',
    noStats: 'Sem estatísticas de assinatura disponíveis.',
    namespace: 'Namespace',
    topic: 'Topic',
    ok: 'OK',
    error: 'Erro',
  },
  analytics: {
    title: 'Painel Executivo',
    subtitle: 'Sigma Pulse Analytics',
    bias: 'Vieses',
    omissions: 'Omissões',
    personal: 'Pessoal',
    score: 'Pontuação',
    responses: 'Respostas',
    participants: 'Participantes',
    period: 'Período',
    ou: 'Unidade Organizacional',
    noData: 'Dados insuficientes',
    completionRate: 'Taxa de conclusão',
    avgByCategory: 'Média por categoria',
    organization: 'Organização',
    fundamentalsRadar: 'Radar de fundamentos',
    heatmapPersonFund: 'Mapa de calor — Pontuação por pessoa e fundamental',
    moduleInDev: 'Módulo em desenvolvimento',
    executiveSubtitle: 'visão executiva',
    exec: {
      ouTech: 'Tecnologia',
      ouOps: 'Operações',
      ouSales: 'Vendas',
    },
    tabs: { summary: 'Resumo', fundamentals: 'Fundamentos', heatmap: 'Mapa de Calor', orgNetwork: 'Rede Organizacional', generational: 'Geracional' },
    filterBar: { allOrg: 'Toda a organização', allBU: 'Todas as BUs', allDept: 'Todos os Deptos', dateFrom: 'De', dateTo: 'Até', allFund: 'Todos os fundamentais', clearFilters: 'Limpar filtros' },
    kpi: { evaluations: 'Avaliações', avgScore: 'Pontuação Média', responseRate: 'Taxa de Resposta', avgPerDay: 'Média / Dia', evaluators: 'Avaliadores', scale: 'escala 1–4', noObservables: 'não observáveis', perDay: 'pesquisas por dia', activeParticipants: 'participantes ativos', ofTotal: 'totais' },
    summary: { topBehaviors: 'Top Daily Habits', topDailyHabitsSubtitle: 'Hábitos com maior impacto cultural', oppSubtitle: 'Hábitos com mais espaço de melhoria', opportunities: 'Áreas de Oportunidade', omissionsByUnit: 'Omissões por Unidade', omissionsSubtitle: 'Taxa de omissão por UO e BU — ordenadas da maior para a menor · Clique em uma UO para ver suas BUs', downloadExcel: 'Baixar Excel', omitType: 'Tipo', omitPeople: 'Pessoas', omitRate: 'Taxa de Omissão', noOmissions: 'Sem omissões significativas', percentileDistribution: 'Distribuição por Percentil', percentileSubtitle: 'Percentual da população em cada faixa de pontuação', personsEvaluated: 'pessoas avaliadas', excellent: 'Excelente', good: 'Bom', developing: 'Em desenvolvimento', attention: 'Atenção', fundPositioning: 'Posicionamento Fundamentos', fundPositioningDesc: 'Ranking, maior/menor pontuação e taxa de não observável por fundamental', highestScore: 'Maior pontuação', lowestScore: 'Menor pontuação', mostNoObs: 'Mais Não Observável', scoreByOU: 'Pontuação por Unidade Organizacional', scoreByOUSubtitle: 'Clique em uma UO para ver o detalhamento por BU e Departamento', person: 'pessoa', persons: 'pessoas' },
    fundamentals: { title: 'Score por Fundamental', subtitle: 'Expanda cada fundamental para ver seus daily habits e detalhes por OU', evalLabel: 'aval', confPreliminary: 'Dado preliminar', confBasedOn: 'Baseado em {{n}} aval' },
    heatmap: { title: 'Mapa de Calor Cultural', subtitle: 'Toque em qualquer linha para explorar suas sub-unidades', unit: 'Unidade', unitOU: 'Unidade Organizacional', unitBU: 'Business Unit', unitDept: 'Departamento', unitPerson: 'Responsável', allOrg: 'Toda a organização', hint: 'Toque qualquer linha para explorar o próximo nível →', person: 'pessoa', persons: 'pessoas', legendCritical: 'Crítico', legendLow: 'Baixo', legendMedium: 'Médio', legendGood: 'Bom', legendExcellent: 'Excelente', noOu: 'Sem UO' },
    ona: { title: 'Rede Organizacional (ONA)', subtitle: 'Árvore interativa das unidades organizacionais (OU)', treeHint: 'Expanda cada nó para navegar pelos níveis de OU da organização.', omissions: 'Omissões', totalPeople: 'Pessoas', avgScore: 'Pontuação média', totalEvals: 'Total de avaliações', collaboratorsKpi: 'Colaboradores', highestOmission: 'Maior omissão', omissionsRanking: 'Ranking de omissões', maturityCulture: 'Maturidade cultural', maturityLegend: 'Legenda de maturidade', maturityInitial: 'Inicial', maturityGrowing: 'Em desenvolvimento', maturityConsolidated: 'Consolidado', maturityRoleModel: 'Modelo de referência', evalsLabel: 'avaliações', noEvals: 'Sem avaliações', collaboratorsLabel: 'colaboradores', omissionLabel: 'omissão', evalsShort: 'avals' },
    gen: { panorama: 'Panorama', ranking: 'Ranking', brechas: 'Lacunas', avgAge: 'Idade média', title: 'Análise Geracional', subtitle: 'Distribuição e maturidade cultural por coorte · {{n}} pessoas mapeadas', noRepresentation: 'Sem representação', scoreLabel: 'Score', omissionLabel: 'Omissão', personas: 'pessoas', age: 'Idade', all: 'Todos', noData: 'Sem dados para este filtro', fundamental: 'Fundamental', gapCol: 'Δ Lacuna', brechaNote: 'Maior lacuna: {{fund}} · Δ {{delta}} pts entre gerações', brechaSource: 'Diferença em relação à média geral do fundamental na organização', responseCount: '{{n}} respostas' },
  },
  userConfig: {
    fabTitle: 'Configurar perfil de usuário',
    title: 'Perfil de usuário (demo)',
    subtitle: 'Modo de teste — simula os dados que virão do Teams SSO na integração com o back-end',
    nombre: 'Nome',
    correo: 'E-mail',
    ou: 'OU (Unidade Organizacional)',
    do_: 'DO (Divisão)',
    bu: 'BU (Unidade de Negócios)',
    departamento: 'Departamento',
    puesto: 'Cargo',
    numeronomina: 'Número de matrícula',
    role: 'Perfil',
    roleDetected: 'Perfil detectado',
    roleNotFound: 'E-mail não encontrado — será usado Funcionário',
    save: 'Salvar perfil',
    namePlaceholder: 'Ex: Ana García',
    emailPlaceholder: 'Ex: agarcia@sigma.com',
    ouPlaceholder: 'Ex: Tecnologia',
    doPlaceholder: 'Ex: Diretoria de TI',
    buPlaceholder: 'Ex: Brasil',
    deptPlaceholder: 'Ex: Desenvolvimento de Software',
    puestoPlaceholder: 'Ex: Engenheiro de Software Sr.',
    nominaPlaceholder: 'Ex: 123456',
    fechaNacimiento: 'Data de nascimento',
    tenant: 'Tenant',
  },
  errors: {
    generic: 'Ocorreu um erro inesperado',
    unauthorized: 'Você não tem permissão para esta ação',
    notFound: 'Recurso não encontrado',
    network: 'Erro de conexão. Verifique sua rede.',
  },
};

export default pt;

